











































import { Component, Vue } from 'vue-property-decorator';

enum ReasonType {
  DEFAULT = 'default',
  ERROR = 'error'
}

@Component({})
export default class Fail extends Vue {
  public reason: ReasonType = ReasonType.DEFAULT;
  public paymentId: string | null = null;
  public ReasonType: typeof ReasonType = ReasonType;

  public mounted() {
    this.paymentId = this.$route.query.paymentId as string;
    this.reason = this.$route.query.reason as ReasonType;
  }
}
